module.exports = __webpack_public_path__ + "static/media/milkbg.dd87e29.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/milkbg.webm
// module id = FB89
// module chunks = 1